<section>
  <ng-container>
    <kl-program-training-form (postCreated)="onPostCreated($event)">
    </kl-program-training-form>
  </ng-container>
</section>
